/* eslint-disable prefer-promise-reject-errors */

import { merge } from 'lodash'
import qs from 'qs'
import { unescape } from 'html-escaper'
import xss from 'xss'

function getLocation(href) {
  const l = document.createElement('a')
  l.href = href
  return l
}

export function replaceRestfulParams(url, params) {
  const path = getLocation(url).pathname
  const restParamSegReg = /:([^/]*)/g
  const replacedPath = path
    .replace(restParamSegReg, (_, seg) => {
      let val = params[seg]
      if (val === undefined) {
        val = `:${seg}`
      }
      return val
    })
    .replace('//', '/')
  return url.replace(path, replacedPath)
}

function stringifyQueryObj(queryObj) {
  return Object.keys(queryObj)
    .map((key) => `${key}=${encodeURIComponent(queryObj[key])}`)
    .join('&')
}

export function concatQuery(url, query = {}) {
  if (Object.keys(query).length === 0) {
    return url
  }
  if (url.indexOf('?') === -1) {
    url = `${url}?`
  }
  const stringifiedQuery = stringifyQueryObj(query)
  if (url[url.length - 1] === '?') {
    return `${url}${stringifiedQuery}`
  }
  return `${url}&${stringifiedQuery}`
}

export function deepMerge(...args) {
  return merge({}, ...args)
}

export function objPropContainStr(
  obj,
  prop,
  expectedContainStr,
  propKeyCaseInsenstive = true
) {
  let value = obj[prop] || ''
  if (value.indexOf(expectedContainStr) > -1) {
    return true
  }
  if (propKeyCaseInsenstive) {
    value = obj[prop.toLowerCase()] || ''
    if (value.indexOf(expectedContainStr) > -1) {
      return true
    }
  }

  return false
}

export function getUniqId() {
  return Math.random().toString(36).substr(2, 9)
}

export function UrlParamHash(url) {
  if (url.indexOf('?') === -1) return {}
  const hash = url.slice(url.indexOf('?') + 1).split('&')
  const params = {}
  hash.forEach((it) => {
    const param = qs.parse(it)
    Object.assign(params, param)
  })
  return params
}

export function unescapeToSafeHtmlStr(str) {
  // 先反转义再去除危险标签
  return xss(unescape(str))
}

export const validPhone = (str) => {
  return /^[0-9+]{4,}$/.test(str)
}

// 中国大陆手机号校验（11位，1开头第二位3-9）
export const validMobile = (str) => {
  return /^1[3-9]\d{9}$/.test(str)
}

export const validBankNum = (str) => {
  return /^[0-9]{16,19}$/.test(str)
}

// 身份证号校验：18位校验末位校验码（GB 11643），15位旧版仅校验数字
export const validIdCardNum = (str) => {
  if (!str) return false
  const s = String(str).trim()
  // 18位：前17位数字 + 末位数字/X
  if (/^\d{17}[\dXx]$/.test(s)) {
    const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    let sum = 0
    for (let i = 0; i < 17; i++) {
      sum += parseInt(s.charAt(i), 10) * weights[i]
    }
    return s.charAt(17).toUpperCase() === checkCodes[sum % 11]
  }
  // 15位旧版身份证：仅校验全数字
  return /^\d{15}$/.test(s)
}

// 身份证号脱敏：保留前4后4
export const maskIdCard = (idCard) => {
  if (!idCard || idCard.length < 8) return idCard
  return idCard.slice(0, 4) + '********' + idCard.slice(-4)
}

// 手机号脱敏：保留前3后4
export const maskPhone = (phone) => {
  if (!phone || phone.length < 7) return phone
  return phone.slice(0, 3) + '****' + phone.slice(-4)
}

export const validEmail = (str) => {
  return /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(str)
}

export const phoneValidator = (rules, value) => {
  if (!validPhone(value)) {
    return Promise.reject('手机号码格式错误')
  }
  return Promise.resolve()
}

export const idCardValidator = (rules, value) => {
  if (!validIdCardNum(value)) {
    return Promise.reject('身份证号格式错误')
  }
  return Promise.resolve()
}

export const bankCardValidator = (rules, value) => {
  if (!validBankNum(value)) {
    return Promise.reject('银行卡号格式错误')
  }
  return Promise.resolve()
}

export const emailValidator = (rules, value) => {
  if (!validEmail(value)) {
    return Promise.reject('邮箱格式错误')
  }
  return Promise.resolve()
}
